import { substitute } from 'js/helpers/i18n';
import { CmsBrowsePage } from 'js/model/cms/cms-browse-page';
import { VenueListingSpecificationOutput } from 'js/model/rainbow/browse-page/VenueListingSpecificationOutput';
import { PaginationOutput } from 'js/model/rainbow/PaginationOutput';
import { generateWhere, generateWhat } from './browse-results-summary';

function isSingleTreatment(
  specification: VenueListingSpecificationOutput
): boolean {
  return Boolean(
    specification.treatmentCategories &&
      specification.treatmentCategories.length === 1
  );
}

function venueType(specification: VenueListingSpecificationOutput): string {
  const venueType = specification.venueType!;
  return venueType.pluralName || venueType.name;
}

export function generateBrowseDescription(
  cms: CmsBrowsePage,
  specification: VenueListingSpecificationOutput,
  resultCount: number
): string {
  const whereFragment = generateWhere(cms, specification.location);
  let whatFragment = specification.venueType
    ? venueType(specification)
    : generateWhat(cms, specification, resultCount);

  // Single treatments get `places for` prefix
  if (!specification.venueType && isSingleTreatment(specification)) {
    whatFragment = substitute(
      cms.page.browse.meta['places-fragment'],
      whatFragment
    );
  }

  return substitute(
    cms.page.browse.meta.description,
    whatFragment,
    whereFragment
  );
}

export function generateBrowseTitle(
  cms: CmsBrowsePage,
  specification: VenueListingSpecificationOutput,
  pagination: PaginationOutput,
  titleOverride?: string
): string {
  const whereFragment = generateWhere(cms, specification.location);
  // resultCount = 2 as title should always be plural
  let whatFragment = generateWhat(cms, specification, 2, titleOverride);

  if (!titleOverride && pagination.totalElements >= pagination.pageSize) {
    // Single treatments get `places for` prefix
    if (!specification.venueType && isSingleTreatment(specification)) {
      whatFragment = substitute(
        cms.page.browse.meta['places-fragment'],
        whatFragment
      );
    }

    return substitute(
      cms.page.browse.meta.title.top,
      String(pagination.pageSize),
      whatFragment,
      whereFragment
    );
  }
  return substitute(
    cms.page.browse.meta.title.normal,
    whatFragment,
    whereFragment
  );
}
